'use client';

import { c as _c } from "react/compiler-runtime";
import { toLowerCase } from 'betterplace-utils';
import { Heading } from 'design-system/client';
import { useTranslations } from 'next-intl';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
function HolderTitle() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["payment_method"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [paymentMethod] = useDonationFormValues(t0);
  const t = useTranslations("nextjs.donate");
  let t1;
  if ($[1] !== paymentMethod) {
    t1 = toLowerCase(paymentMethod);
    $[1] = paymentMethod;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `holder_title.${t1}`;
  let t3;
  if ($[3] !== t || $[4] !== t2) {
    t3 = t(t2);
    $[3] = t;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Heading level="heading-xs">{t3}</Heading>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export default HolderTitle;